(() => {
  const SECTION_CLASS = "social-media-section";
  const instances = new WeakMap();
  const reducedMotion =
    window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)");

  class SocialMediaTicker {
    constructor(root) {
      this.root = root;
      // The wrapper (.social-media-images) carries the ticker type/speed data and
      // the .is-ticker-ready hook the CSS animation keys off; the track (root,
      // .js-social-media-ticker) holds the lane(s) / ring.
      this.wrapper = root.closest(".social-media-images") || root;
      this.type =
        this.wrapper.dataset.tickerType === "vertical" ? "vertical" : "radial";

      // Speed 1 = slowest, 30 = fastest. Map to an animation duration (80s..22s).
      const speed = Number(this.wrapper.dataset.tickerSpeed) || 15;
      this.duration = (41 - speed) * 2;

      this.clones = [];

      // prefers-reduced-motion: leave the static markup (radial cards already sit
      // on the arc via server-side angles), never start the loop.
      if (reducedMotion && reducedMotion.matches) return;

      this.wrapper.style.setProperty("--ticker-duration", `${this.duration}s`);

      if (this.type === "vertical") {
        this._buildColumns();
      } else {
        this._buildRing();
      }

      this.wrapper.classList.add("is-ticker-ready");
    }

    _buildRing() {
      // Cards are placed on the ring server-side (per-tile --card-i via nth-child)
      // so the arc is correct before JS runs; here we only (re)assert the angular
      // positions defensively, then .is-ticker-ready starts the CSS spin.
      this.ring = this.root.querySelector(".js-social-media-ring");
      if (!this.ring) return;

      const tiles = Array.from(
        this.ring.querySelectorAll(".social-media-image")
      );
      if (!tiles.length) return;

      const total = Number(this.root.dataset.totalSlides) || tiles.length;
      this.ring.style.setProperty("--card-total", String(total));
      tiles.forEach((tile, index) => {
        tile.style.setProperty("--card-i", String(index));
      });
    }

    _buildColumns() {
      // Each column loops seamlessly: duplicate its lane so the column holds two
      // identical lanes and translates by exactly one lane length. Direction
      // (up/down) comes from the column's data-direction.
      const columns = Array.from(
        this.root.querySelectorAll(".js-social-media-column")
      );
      if (!columns.length) return;

      columns.forEach((column) => {
        const lane = column.querySelector(".js-social-media-lane");
        if (!lane) return;
        const clone = lane.cloneNode(true);
        clone.classList.add("social-media-images__lane--clone");
        clone.setAttribute("aria-hidden", "true");
        lane.after(clone);
        this.clones.push(clone);
      });
    }

    destroy() {
      this.clones.forEach((clone) => clone.remove());
      this.clones = [];
      this.wrapper.classList.remove("is-ticker-ready");
      this.wrapper.style.removeProperty("--ticker-duration");
    }
  }

  const initSection = (section) => {
    if (!section || !section.classList.contains(SECTION_CLASS)) return;

    section.querySelectorAll(".js-social-media-ticker").forEach((root) => {
      const existing = instances.get(root);
      if (existing) {
        existing.destroy();
        instances.delete(root);
      }
      instances.set(root, new SocialMediaTicker(root));
    });
  };

  initSection(document.currentScript.parentElement);

  if (!window.__themeSocialMediaTickerEvents) {
    window.__themeSocialMediaTickerEvents = true;

    document.addEventListener("shopify:section:load", (event) => {
      initSection(event.target);
    });

    document.addEventListener("shopify:section:unload", (event) => {
      event.target
        .querySelectorAll(".js-social-media-ticker")
        .forEach((root) => {
          const existing = instances.get(root);
          if (!existing) return;
          existing.destroy();
          instances.delete(root);
        });
    });
  }
})();
